
export interface ConfiguracionModeloTabla {
  IdUsuario: number; // IDCargador
  Nombre: string; // PotenciaMax
  Email: string;
}
